// extracted by mini-css-extract-plugin
export default {"feedback":"Results_feedback__PMsJq","loading":"Results_loading__8y11s","item":"Results_item__CU2qu"};